export default "__VITE_ASSET__CaY71D8___"